// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"06f77541","137":"b9e40f6b","213":"2e56dd17","293":"31c0dd32","358":"d21a55cd","419":"00f20603","455":"e58fa281","488":"0b3827e9","581":"e82b8e5b","606":"9dfaf6d6","621":"1accbaa3","870":"873de4e1"}[chunkId] + ".chunk.js";
};